import SessionService from '../session/session.service.js';
import { QUERY_PARAMS } from '../../constants/login.constants.js';
import { DebugService } from '../debug/debug.service.js';

class _SsoService {
  constructor() {
    this.debug = new DebugService('SSO Service');
  }

  get baseSSOConfig() {
    switch (window.location.hostname) {
      case 'coaf-refi-web-ui.capitalone.com':
      case 'autorefi.capitalone.com':
        return {
          url: 'https://api.capitalone.com/oauth/auz/authorize',
          clientId: 'd2dc227e1f04f4196143a78640d5b80a',
        };
      default:
        return {
          url: 'https://api-it.capitalone.com/oauth2/authorize',
          clientId: '4b8bdd9c03cc15453cc45fcdd43fa562',
        };
    }
  }

  createStateParam() {
    const stateKey = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(20))));
    const searchParams = new URLSearchParams(window.location.search);

    SessionService.setSsoCapturedState(stateKey, {
      externalId: searchParams.get(QUERY_PARAMS.EXTERNAL_ID),
      rl: searchParams.get(QUERY_PARAMS.LEADS),
      banditExperimentId: searchParams.get(QUERY_PARAMS.BANDIT_EXPERIMENT_ID),
      banditFeedbackId: searchParams.get(QUERY_PARAMS.BANDIT_FEEDBACK_ID),
      PFFSRCID: searchParams.get(QUERY_PARAMS.PFFSRCID),
      refi_analytics: searchParams.get(QUERY_PARAMS.REFI_ANALYTICS),
      refi_allocation: searchParams.get(QUERY_PARAMS.REFI_ALLOCATION),
    });
    return stateKey;
  }

  get baseURL() {
    const ssoURL = new URL(this.baseSSOConfig.url);
    ssoURL.searchParams.append('scope', 'ncUniversalId openid');
    ssoURL.searchParams.append('response_type', 'code');
    ssoURL.searchParams.append('grant_type', 'authorization_code');
    ssoURL.searchParams.append('client_id', this.baseSSOConfig.clientId);
    return ssoURL;
  }

  goToSSORegistrationLink() {
    const ssoURL = this.baseURL;
    const redirectURL = new URL('/login/processing-login', window.location.origin);
    ssoURL.searchParams.append('redirect_uri', redirectURL.toString());
    ssoURL.searchParams.append('state', this.createStateParam());
    ssoURL.searchParams.append('prompt', 'create');
    this.debug.log(ssoURL.toString());
    window.open(ssoURL.toString(), '_self');
  }

  goToSsoLoginLink() {
    const ssoURL = this.baseURL;
    ssoURL.searchParams.append('state', this.createStateParam());
    const redirectURL = new URL('/login/processing-login', window.location.origin);
    ssoURL.searchParams.append('redirect_uri', redirectURL.toString());
    this.debug.log('redirect url: ', ssoURL.toString());

    window.open(ssoURL.toString(), '_self');
  }

  goToStsLoginLink(stsToken) {
    const ssoURL = this.baseURL;
    ssoURL.searchParams.append('state', this.createStateParam());
    const redirectURL = new URL('/login/processing-login', window.location.origin);
    ssoURL.searchParams.append('redirect_uri', redirectURL.toString());
    ssoURL.searchParams.append('login_token_hint', stsToken.toString());
    this.debug.log('redirect url: ', ssoURL.toString());
    SessionService.setAttemptedStsBypass(true);

    window.open(ssoURL.toString(), '_self');
  }
}

const SsoService = new _SsoService();

export default SsoService;
